import { ProductImage } from "@/types";

export const images: ProductImage[] = [
  {
    name: "Ardore",
    desc: "An original effect, which distinguishes itself with a fake deepness between pearl and opaque. Exclusive fragments of precious pearls which are gently pressed during the application phase, leaves a pearlescent trail on the surface, with a warmth three-dimensional effect and...a flame of elegance.",
    title: "Flash Pearl Decorative System",
    default: "/images/331-ardore-en/Ardore1.jpg",
    images: [
      "/images/331-ardore-en/Ardore1.jpg",
      "/images/331-ardore-en/ARDORE22.jpg",
      "/images/331-ardore-en/Ardore2.jpg",
      "/images/331-ardore-en/Ardore3.jpg",
      "/images/331-ardore-en/Ardore4.jpg",
    ],
  },
  {
    name: "ArtheMetal",
    desc: "The Metallic effect for top class Decoration. Studied in very minor details, ArtheMetal boasts of 4 spectacular effects: the elegant and original Gold Leaf Effect, the attractive Frisè Effect, the simple but suggestive Pennellato Effect and the inimitable Rigato Effect. ArtheMetal, a style for real experts!",
    title: "Metallic Effect Decorative Paint",
    default: "/images/332-arthe-metal-en/AM2.jpg",
    images: [
      "/images/332-arthe-metal-en/AM2.jpg",
      "/images/332-arthe-metal-en/AM3.jpg",
      "/images/332-arthe-metal-en/AM.jpg",
      "/images/332-arthe-metal-en/ArtheMetal1.jpg",
      "/images/332-arthe-metal-en/ArtheMetal3.jpg",
      "/images/332-arthe-metal-en/ArtheMEtal4.jpg",
    ],
  },
  {
    name: "Caravaggio",
    desc: "Caravaggio combines the precious features of the Venetian stuccoes with the original elegance, softness and l ight effects typical of the ancient wall fabrics, used in the Renaissance. Caravaggio allows to obtain some extraordinary results (never seen before with other traditional paints) by exploiting the decorative abilities and creativity of the painter who can create original nuances with every different application, suitable for all kinds of environments.",
    title: "Velvet Effect Decorative “Stucco”",
    default: "/images/333-caravaggio-en/caravaggio2bis.jpg",
    images: [
      "/images/333-caravaggio-en/Caravaggio1.jpg",
      "/images/333-caravaggio-en/caravaggio2bis.jpg",
      "/images/333-caravaggio-en/Caravaggio2.jpg",
      "/images/333-caravaggio-en/Caravaggio33.jpg",
      "/images/333-caravaggio-en/Caravaggio4.jpg",
      "/images/333-caravaggio-en/caravaggiobroccato.jpg",
      "/images/333-caravaggio-en/Caravaggiodamascato88.jpg",
      "/images/333-caravaggio-en/CARAVAGGIOdam.jpg",
    ],
  },
  {
    name: "Caravaggio Pearl",
    desc: "Caravaggio combines the precious features of the Venetian stuccoes with the original elegance, softness and l ight effects typical of the ancient wall fabrics, used in the Renaissance. Caravaggio allows to obtain some extraordinary results (never seen before with other traditional paints) by exploiting the decorative abilities and creativity of the painter who can create original nuances with every different application, suitable for all kinds of environments.   ...una fiamma di eleganza.",
    title: "...with Madreperla Reflex",
    default: "/images/334-caravaggio-pearl-en/CaravaggioPearl1jpg.jpg",
    images: [
      "/images/334-caravaggio-pearl-en/CaravaggioPearl1jpg.jpg",
      "/images/334-caravaggio-pearl-en/CaravaggioPearl2.jpg",
      "/images/334-caravaggio-pearl-en/caravaggioverde.jpg",
    ],
  },
  {
    name: "Ceralux",
    desc: "Polichrome decorative system for iridescent finishes with a pearly oranon - pearly quality. Can be cleaned and, depending on the setting, worked in a number of ways: padded, spatulated,dripped, painted, sponged, etc.",
    title: "Fetching modern style!",
    default: "/images/335-ceralux-en/Ceralux2.jpg",
    images: [
      "/images/335-ceralux-en/Ceralux1.jpg",
      "/images/335-ceralux-en/Ceralux_26.jpg",
      "/images/335-ceralux-en/Ceralux2.jpg",
    ],
  },
  {
    name: "CoccioPesto",
    desc: "Decorative lime putty with cocciopesto grains, combining the “sfiammature” effect typical of the cocciopesto and the lime putty translucent quality.",
    title: "Lime putty with Terracotta grains!",
    default: "/images/336-cocciopesto-en/Cocciopesto1.jpg",
    images: [
      "/images/336-cocciopesto-en/Cocciopesto1.jpg",
      "/images/336-cocciopesto-en/Cocciopesto2.jpg",
      "/images/336-cocciopesto-en/Cocciopesto3.jpg",
      "/images/336-cocciopesto-en/cocc.jpg",
    ],
  },
  {
    name: "Decorà",
    desc: "",
    title: "Antique-Looking Decoration System Allows to obtain chiaroscuro finishes ideal for antique-looking and country - style settings. Aveiled surface dotted by small particles that look like painting and feel like low -relief to the touch.",
    default: "/images/337-decora-en/Decora1.jpg",
    images: [
      "/images/337-decora-en/Decora1.jpg",
      "/images/337-decora-en/Decora_4.jpg",
      "/images/337-decora-en/Decora_7.jpg",
    ],
  },
  {
    name: "Decorà Gold",
    desc: "Allows to obtain chiaroscuro finishes ideal for antique-looking and country - style settings. Aveiled surface dotted by small particles that look like painting and feel like low -relief to the touch.",
    title: "Enriched by elegant gold flakes",
    default: "/images/338-decora-gold-en/Decora_9.jpg",
    images: [
      "/images/338-decora-gold-en/Decora_2.jpg",
      "/images/338-decora-gold-en/Decora_9.jpg",
      "/images/338-decora-gold-en/decoragold1.jpg",
      "/images/338-decora-gold-en/Decoragold2.jpg",
    ],
  },
  {
    name: "Decorà DeLuxe",
    desc: "Decorative System with a pearlescent effect which is obtained through the combination of soft coloured grains and a vast variet y of pearls.",
    title: "The elegance of pearlescent effect",
    default: "/images/339-decora-deluxe-en/Decoradeluxe5.jpg",
    images: [
      "/images/339-decora-deluxe-en/Decoradeluxe1.jpg",
      "/images/339-decora-deluxe-en/decoradeluxe2.jpg",
      "/images/339-decora-deluxe-en/decoradeluxe3.jpg",
      "/images/339-decora-deluxe-en/Decoradeluxe4.jpg",
      "/images/339-decora-deluxe-en/Decoradeluxe5.jpg",
      "/images/339-decora-deluxe-en/decordeluxel.jpg",
      "/images/339-decora-deluxe-en/DELUXE2.jpg",
    ],
  },
  {
    name: "Encausto Fiorentino",
    desc: "Resulting from the ancient synergy of particular marble chips with lime putty, for elegant and original marble - looking opaque and semi - opaque effects.",
    title: "Wonderful “marmorino” Effect",
    default: "/images/340-encausto-fiorentino-en/encausto2.jpg",
    images: [
      "/images/340-encausto-fiorentino-en/01.jpg",
      "/images/340-encausto-fiorentino-en/02.jpg",
      "/images/340-encausto-fiorentino-en/03.jpg",
      "/images/340-encausto-fiorentino-en/04.jpg",
      "/images/340-encausto-fiorentino-en/05.jpg",
      "/images/340-encausto-fiorentino-en/06.jpg",
      "/images/340-encausto-fiorentino-en/07.jpg",
      "/images/340-encausto-fiorentino-en/08.jpg",
      "/images/340-encausto-fiorentino-en/09.jpg",
      "/images/340-encausto-fiorentino-en/encausto2.jpg",
      "/images/340-encausto-fiorentino-en/encausto.jpg",
    ],
  },
  {
    name: "Krystalia",
    desc: "The magic touch of crystal has finally arrived on your walls! A noble mineral, thanks to its geometrical shape, is able to convey really impressive light reflection. Have you ever imagined such a decorative effect? Open your eyes, Krystalia is in front of You! Avete mai immaginato un simile effetto decorativo? Aprite gli occhi, c’è Krystalia davanti a Voi !!!",
    title: "Crystal Effect Decorative Paint",
    default: "/images/341-krystalia-en/Krystalia1.jpg",
    images: [
      "/images/341-krystalia-en/K2.jpg",
      "/images/341-krystalia-en/K3.jpg",
      "/images/341-krystalia-en/Krystaia2.jpg",
      "/images/341-krystalia-en/Krystalia1.jpg",
      "/images/341-krystalia-en/Krystalia3.jpg",
    ],
  },
  {
    name: "Nahir Rigato",
    desc: "This decorative system has a very special Stucco which is easy to model and this allows you to create endless effects. With the application of Velatura Classic or Pearl on top it seems to create transparency, deepness and a unique and fascinating dark light contrast. 3 methods of application:Rigato, Broccato, Cracklè.",
    title: "Meteric Decorative Sistem",
    default: "/images/342-nahir-rigato-en/nahirrigato4.jpg",
    images: [
      "/images/342-nahir-rigato-en/NAHIR2.jpg",
      "/images/342-nahir-rigato-en/nahir99.jpg",
      "/images/342-nahir-rigato-en/nahirrigato3jpg.jpg",
      "/images/342-nahir-rigato-en/nahirrigato4.jpg",
      "/images/342-nahir-rigato-en/NR1.jpg",
      "/images/342-nahir-rigato-en/NR2.jpg",
      "/images/342-nahir-rigato-en/RIGATO1.jpg",
    ],
  },
  {
    name: "Nahir Cracklè",
    desc: "This decorative system has a very special Stucco which is easy to model and this allows you to create endless effects. With the application of Velatura Classic or Pearl on top it seems to create transparency, deepness and a unique and fascinating dark light contrast. 3 methods of application: Rigato, Broccato, Cracklè.",
    title: "Materic Decorative Sistem",
    default: "/images/343-nahir-crackle-en/cracle2.jpg",
    images: [
      "/images/343-nahir-crackle-en/cracle1.jpg",
      "/images/343-nahir-crackle-en/cracle2.jpg",
      "/images/343-nahir-crackle-en/cracle3.jpg",
    ],
  },
  {
    name: "Nahir Broccato",
    desc: "This decorative system has a very special Stucco which is easy to model and this allows you to create endless effects. With the application of Velatura Classic or Pearl on top it seems to create transparency, deepness and a unique and fascinating dark light contrast. 3 methods of application: Rigato, Broccato, Cracklè.",
    title: "Materic Decorative Sistem",
    default: "/images/344-nahir-broccato-en/broccato1.jpg",
    images: [
      "/images/344-nahir-broccato-en/broccato1.jpg",
      "/images/344-nahir-broccato-en/broccato.jpg",
      "/images/344-nahir-broccato-en/NB.jpg",
    ],
  },
  {
    name: "New Concept",
    desc: "The Decorative system NEW CONCEPT effetto travertino discovers and values the aristocratic effect of the famous Italian Marblewith anabsolutely innovative style. It is a wall finish that allows you to obtain tones, colours and a sensation which up to now was not obtainable with travertino.",
    title: "Travertino Effect",
    default: "/images/345-new-concept-effetto-travertino-en/travertino2.jpg",
    images: [
      "/images/345-new-concept-effetto-travertino-en/traver.jpg",
      "/images/345-new-concept-effetto-travertino-en/travertino2.jpg",
      "/images/345-new-concept-effetto-travertino-en/travertino3.jpg",
      "/images/345-new-concept-effetto-travertino-en/travertino4.jpg",
      "/images/345-new-concept-effetto-travertino-en/travertino5.jpg",
      "/images/345-new-concept-effetto-travertino-en/travertino6.jpg",
      "/images/345-new-concept-effetto-travertino-en/Travertinobianco.jpg",
      "/images/345-new-concept-effetto-travertino-en/Travertinoblu.jpg",
      "/images/345-new-concept-effetto-travertino-en/travertino.jpg",
      "/images/345-new-concept-effetto-travertino-en/Travertinonerojpg.jpg",
      "/images/345-new-concept-effetto-travertino-en/Travertinorosso.jpg",
      "/images/345-new-concept-effetto-travertino-en/Travertinoverde.jpg",
      "/images/345-new-concept-effetto-travertino-en/TS.jpg",
    ],
  },
  {
    name: "Nobilis ",
    desc: "Unique, Magnificent, Charming ... the first adjectives suitable for a decorative effect of extraordinary beauty, which is a real and absolute novelty in the top class wall decoration. A refined specialty, developed directly from the Spiver Lab &amp; Arthe Academy, which allows you to recreate, on any surface, the same tactile sensation and visual of some of the most famous Noble precious metals such as Platinum, Gold, or Silver. Create a spatula effect of pure platinum or a “damascato” effect of pure gold or a striped effect of pure silver is now possible! An unlimited number of effects and a wide color range. Nobilis, a new luxury for your environment.",
    title: "The precious “Real Metal”!",
    default: "/images/346-nobilis-en/nobilis.jpg",
    images: [
      "/images/346-nobilis-en/Etna_Nobilis.jpg",
      "/images/346-nobilis-en/nobilis2.jpg",
      "/images/346-nobilis-en/nobilis3.jpg",
      "/images/346-nobilis-en/nobilis4.jpg",
      "/images/346-nobilis-en/Nobilis6.jpg",
      "/images/346-nobilis-en/nobilis7.jpg",
      "/images/346-nobilis-en/nobilis.jpg",
      "/images/346-nobilis-en/nobil.jpg",
    ],
  },
  {
    name: "Rust Style",
    desc: "The Cor - Ten effect, contemporary style even more real, with an area of endless colours and shades, warm, light and dark. It is generally used in top class design environments, that want to stand out their exclusivity with breathtaking elegance.",
    title: "Cor -Ten Effect Decorative System",
    default: "/images/347-rust-style-en/rust3.jpg",
    images: [
      "/images/347-rust-style-en/rust1.jpg",
      "/images/347-rust-style-en/rust2.jpg",
      "/images/347-rust-style-en/rust3.jpg",
      "/images/347-rust-style-en/rust4.jpg",
    ],
  },
  {
    name: "StuccoMarmo",
    desc: "Superior, marble - looking lime putty for the glossy or translucent finishes typical of Renaissance villas.",
    title: "Arthe - style spatulated lime putty!",
    default: "/images/348-stuccomarmo-en/stuccomar.jpg",
    images: [
      "/images/348-stuccomarmo-en/stuccomar1.jpg",
      "/images/348-stuccomarmo-en/stuccomar2.jpg",
      "/images/348-stuccomarmo-en/stuccomar3.jpg",
      "/images/348-stuccomarmo-en/stuccomar4.jpg",
      "/images/348-stuccomarmo-en/stuccomar5.jpg",
      "/images/348-stuccomarmo-en/stuccomar6.jpg",
      "/images/348-stuccomarmo-en/stuccomar.jpg",
      "/images/348-stuccomarmo-en/stuccomarmo4.jpg",
      "/images/348-stuccomarmo-en/stuccomarmo82.jpg",
    ],
  },
  {
    name: "Velatura Classica",
    desc: "A system of simple application, where the typical nuvolato and chiaro scuro effects of the velatura prevail over the smooth base. Ideal for decorating the wall surfaces of homes and buildings that aim at r e creating a classic, antique -looking feel.",
    title: "Silossanic layer on a smoot surface",
    default: "/images/349-velatura-classica-en/velatura2.jpg",
    images: [
      "/images/349-velatura-classica-en/interno_2.jpg",
      "/images/349-velatura-classica-en/velatura1.jpg",
      "/images/349-velatura-classica-en/velatura2.jpg",
      "/images/349-velatura-classica-en/velatura3.jpg",
    ],
  },
  {
    name: "Velatura Rustica",
    desc: "Ideal for country - style interiors or other particular settings. Also suitable for use in the outside (historic areas, villas and elegant palaces), where the antique -looking feel of velatura silossanica, characterized by a semitrans parent quality and the typical chiaro scuro effect of the velatura, is wanted.",
    title: "Country - Style Layer!",
    default: "/images/350-velatura-rustica-en/rustica4.jpg",
    images: [
      "/images/350-velatura-rustica-en/rustica1.jpg",
      "/images/350-velatura-rustica-en/rustica2.jpg",
      "/images/350-velatura-rustica-en/rustica3.jpg",
      "/images/350-velatura-rustica-en/rustica4.jpg",
      "/images/350-velatura-rustica-en/VelaturaRustica1.jpg",
    ],
  },
  {
    name: "Zephyro",
    desc: "Like a strong wind of precious sand, Zephyro is a decorative paint based on selected ceramic grains, wrapped in a precious gold or silver mixture, creating a unique sandy metal effect. Zephyro enand brings back the classic style.",
    title: "Decorative with a Sandy Metallic Effect",
    default: "/images/351-zephyro-en/11.jpg",
    images: [
      "/images/351-zephyro-en/11.jpg",
      "/images/351-zephyro-en/Z1.jpg",
      "/images/351-zephyro-en/Z2.jpg",
      "/images/351-zephyro-en/ze2.jpg",
      "/images/351-zephyro-en/ze3.jpg",
      "/images/351-zephyro-en/ZE4.jpg",
      "/images/351-zephyro-en/ZEPHYROO.jpg",
      "/images/351-zephyro-en/zephyroSpiver78.jpg",
    ],
  },
  {
    name: "Zephyro Pearl",
    desc: "Like a strong wind of precious sand, Zephyro is a decorative paint based on selected ceramic grains, wrapped in a precious gold or silver mixture, creating a unique sandy metal effect. Zephyro enand brings back the classic style.",
    title: "...with Madreperla Reflex",
    default: "/images/352-zephyro-pearl-en/zep2.jpg",
    images: [
      "/images/352-zephyro-pearl-en/zep1.jpg",
      "/images/352-zephyro-pearl-en/zep2.jpg",
      "/images/352-zephyro-pearl-en/zep3.jpg",
    ],
  },
  {
    name: "Feel",
    desc: "Exquisite wall finish &#34;matt-paint with the extraordinary tactile softness. Shabby and minimal effect, maximum opacity, obtaining valuable and variable design solution. FEEL...a lovely finish to live...and above all to touch!",
    title: "Soft and Tactile Decorative System",
    default: "/images/421-feel-en/4.jpg",
    images: [
      "/images/421-feel-en/2.jpg",
      "/images/421-feel-en/4.jpg",
      "/images/421-feel-en/5.jpg",
      "/images/421-feel-en/6.jpg",
      "/images/421-feel-en/7.jpg",
      "/images/421-feel-en/Feel1.jpg",
      "/images/421-feel-en/FEEL2.jpg",
    ],
  },
  {
    name: "OxyD'Arthe",
    desc: "Original Decorative System, ecological and water-based, which makes it possible to be applied on any surface, real oxidation which naturally appears on old aged rusted iron surfaces. 4 different shades of oxidation, which can be multiplied in order to obtain numerous easy finishes, it makes OxyD’Arthe an extremely special finish in top class decorative surroundings. OxyD’Arthe, the right product to refashion the vintage style of true rust, in any desired environment !",
    title: "Authentic oxidation, for any surface!",
    default: "/images/424-oxyd-arthe-en/o2.jpg",
    images: [
      "/images/424-oxyd-arthe-en/o1.jpg",
      "/images/424-oxyd-arthe-en/o2.jpg",
      "/images/424-oxyd-arthe-en/o3.jpg",
      "/images/424-oxyd-arthe-en/o4.jpg",
      "/images/424-oxyd-arthe-en/o5.jpg",
      "/images/424-oxyd-arthe-en/o6.jpg",
      "/images/424-oxyd-arthe-en/o7.jpg",
      "/images/424-oxyd-arthe-en/Oxy.jpg",
    ],
  },
  {
    name: "Suspense Alluminio",
    desc: "Precious decorative painting soft touch where the smooth surface seems to dissolve naturally with soft ripples, characteristic of this finish.   ALLUMINIO: characterized by soft heaps that transformed into brilliant and very elegant reflections.",
    title: "Decorative paint with soft shades",
    default: "/images/463-suspense-alluminio-2/atollo.jpg",
    images: [
      "/images/463-suspense-alluminio-2/32.jpg",
      "/images/463-suspense-alluminio-2/Alluminio.jpg",
      "/images/463-suspense-alluminio-2/atollo.jpg",
    ],
  },
  {
    name: "Suspense Matt",
    desc: "Precious decorative painting soft touch where the smooth surface seems to dissolve naturally with soft ripples, characteristic of this finish.   MATT: a white reflection with aesthetic impact, typical of shabby style and minimal.",
    title: "Decorative Paint with soft shades Matt",
    default: "/images/464-suspense-matt-en/Suspense-Room.jpg",
    images: [
      "/images/464-suspense-matt-en/1.jpg",
      "/images/464-suspense-matt-en/ma.jpg",
      "/images/464-suspense-matt-en/matt1.jpg",
      "/images/464-suspense-matt-en/Suspense-Room.jpg",
    ],
  },
  {
    name: "Suspense Silver",
    desc: "Precious decorative painting soft touch where the smooth surface seems to dissolve naturally with soft ripples, characteristic of this finish.   SILVER: with silver and very classic movements that recall elegance ancient lace fabrics, among the finest of Italian tradition.",
    title: "Decorative Paint with Soft shades Silver",
    default: "/images/465-suspense-silver-en/silver.jpg",
    images: [
      "/images/465-suspense-silver-en/4.jpg",
      "/images/465-suspense-silver-en/Silver5.jpg",
      "/images/465-suspense-silver-en/silver.jpg",
    ],
  },
  {
    name: "MarmOpaco",
    desc: "",
    title: "The lime putty, with classic marmorino effect, transformed, and renewed under new style: the new materials of the Arthe Line, between the simplicity of the opaque and the timeless elegance of pearlescense.   MARMOPACO: the innovative &#34;Marmorino&#34; totally opaque and with a sensational tactile softness.",
    default: "/images/467-marmopaco-en/Marmoopaco2.jpg",
    images: [
      "/images/467-marmopaco-en/1.jpg",
      "/images/467-marmopaco-en/Marmoopaco2.jpg",
      "/images/467-marmopaco-en/Marmopaco3.jpg",
      "/images/467-marmopaco-en/Marmopaco4.jpg",
      "/images/467-marmopaco-en/Marmopaco5.jpg",
    ],
  },
  {
    name: "MarmoPerla",
    desc: "",
    title: "The lime putty, with classic marmorino effect, transformed, and renewed under new style: the new materials of the Arthe Line, between the simplicity of the opaque and the timeless elegance of pearlescense.   MARMOPERLA: the classic &#34;Marmorino&#34; finally with Madreperla.",
    default: "/images/468-marmperla-en/3.jpg",
    images: [
      "/images/468-marmperla-en/1.jpg",
      "/images/468-marmperla-en/2.jpg",
      "/images/468-marmperla-en/3.jpg",
      "/images/468-marmperla-en/4.jpg",
    ],
  },
  {
    name: "Rust Style Light",
    desc: "The Cor - Ten effect, contemporary style even more real, with an area of endless colours and shades, warm, light and dark. It is generally used in top class design environments, that want to stand out their exclusivity with breathtaking elegance. Now in a wonderful selection of light colors in full shabby style.",
    title: "Bright shades in Shabby Chic Style",
    default: "/images/500-rust-style-light-en/rustLight3.jpg",
    images: [
      "/images/500-rust-style-light-en/rustLight1.jpg",
      "/images/500-rust-style-light-en/rustLight2.jpg",
      "/images/500-rust-style-light-en/rustLight3.jpg",
      "/images/500-rust-style-light-en/RustStyleLightG2.jpg",
      "/images/500-rust-style-light-en/RustStyleLightG.jpg",
    ],
  },
];
